// extracted by mini-css-extract-plugin
export default {"entry":"EBlc0uqq"};